var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudOpen64(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "64px",
    width: "64px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-351 153 256 256",
    xmlSpace: "preserve",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 2.56
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-312.5,344.7c-18.3,0-33.1-14.9-33.1-33.1c0-18.2,14.9-33.1,33.2-33.1c0.1,0,0.3,0,0.4,0c2.6-22.2,21.6-39.6,44.5-39.6 c2.6,0,5.2,0.2,8,0.8c6.6-27.9,31.8-48.3,60.9-48.3c34.6,0,62.7,28.1,62.7,62.7c0,0.1,0,0.3,0,0.4c22.6,2.2,40.4,21.4,40.4,44.5 c0,24.7-20,44.7-44.7,44.7C-141.8,343.8-310.8,344.7-312.5,344.7z M-308.3,287.8c-12.1,0-21.9,9.8-21.9,21.8s9.8,21.8,21.8,21.8 c6.7,0,163.3-0.8,164.5-0.8c18.1,0,32.8-14.8,32.8-32.8s-14.7-32.8-32.7-32.8c-0.5,0.1-0.8,0.1-1.2,0.1h-5.5l0.6-5.5 c0.2-1.6,0.2-3.2,0.2-4.8c0-27.5-22.4-49.9-49.9-49.9c-24.7,0-46,18.5-49.4,43l-0.8,5.8l-5.6-1.8c-3.7-1.2-6.9-1.7-10.1-1.7 c-17.8-0.1-32.5,14.3-32.7,32.3c0.1,0.3,0.1,0.6,0.1,1v5.8l-5.8-1.1C-305.6,287.9-306.9,287.8-308.3,287.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOpen64);
export default __webpack_public_path__ + "static/media/cloudOpen64.31b488be394c596fb17f0c0b2f0730f8.svg";
export { ForwardRef as ReactComponent };